import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { FornecedorProduto } from "../cadastro/fornecedor-produto";
import { SolicitacaoCompraItemCotacao } from "../managers/solicitacao-compra-item-cotacao";
import { SolicitacaoCompraFornecedor } from "../persistences/solicitacao-compra-fornecedor";
import { ConfigService } from "./config.service";

@Injectable({
	providedIn: 'root'
})
export class CotacaoService {

	constructor(
		private httpClient: HttpClient,
		private configService: ConfigService
	) { }

	getUnidadesFornecedor(sol: SolicitacaoCompraFornecedor): Observable<any> {
		let httpParams = new HttpParams();
		httpParams = httpParams
			.append('idGeral', sol.idGeral.toString());
		return this.httpClient.get<SolicitacaoCompraFornecedor>(
			this.configService.getEndereco() + '/cotacao/getUnidadesFornecedor',
			{
				headers: this.configService.getHeaders(),
				params: httpParams
			}).pipe(
				map((res: SolicitacaoCompraFornecedor) => res)
			);
	}

	getCodigosFornecedor(sol: SolicitacaoCompraFornecedor): Observable<FornecedorProduto[]> {
		let httpParams = new HttpParams();
		httpParams = httpParams
			.append('idGeral', sol.idGeral.toString());
		return this.httpClient.get<FornecedorProduto[]>(
			this.configService.getEndereco() + '/cotacao/getCodigosFornecedor',
			{
				headers: this.configService.getHeaders(),
				params: httpParams
			});
	}

	getCotacao(cdFilial: number, nrSolicitacao: number): Observable<SolicitacaoCompraFornecedor> {
		let httpParams = new HttpParams();
		httpParams = httpParams
			.append('cdFilial', cdFilial.toString())
			.append('nrSolicitacao', nrSolicitacao.toString());
		return this.httpClient.get<SolicitacaoCompraFornecedor>(this.configService.getEndereco() + '/cotacao/cotacao',
			{ headers: this.configService.getHeaders(), params: httpParams });
	}

	getSolicitacoes(): Observable<SolicitacaoCompraFornecedor[]> {
		return this.httpClient.get<SolicitacaoCompraFornecedor[]>(
			this.configService.getEndereco() + '/cotacao/solicitacoes',
			{
				headers: this.configService.getHeaders()
			});
	}

	getSolicitacoesCompletas(): Observable<SolicitacaoCompraFornecedor[]> {		
		return this.httpClient.get<SolicitacaoCompraFornecedor[]>(
			this.configService.getEndereco() + "/cotacao/solicitacoesCompletas",
			{
				headers: this.configService.getHeaders()
			})
	}

	setEmEdicao(sol: SolicitacaoCompraFornecedor): Observable<any> {
		let httpParams = new HttpParams();
		httpParams = httpParams
			.append('idGeral', sol.idGeral.toString());
		return this.httpClient.get(this.configService.getEndereco() + '/cotacao/editar',
			{
				headers: this.configService.getHeaders(),
				params: httpParams,
			});
	}

	enviarCotacoes(cotacao: SolicitacaoCompraFornecedor): Observable<any> {
		return this.httpClient.post(this.configService.getEndereco() + '/cotacao/cotacoes',
			JSON.stringify(cotacao),
			{
				headers: this.configService.getHeaders(),
			});
	}

	enviarItem(item: SolicitacaoCompraItemCotacao): Observable<any> {				
		return this.httpClient.post(this.configService.getEndereco() + '/cotacao/salvarItem',
		JSON.stringify(item),
			{
				headers: this.configService.getHeaders(),
			});
	}

	getXls(cdFilial: number, nrSolicitacao: number) {
		let httpParams = new HttpParams();
		httpParams = httpParams.
			append("cdFilial", cdFilial.toString()).
			append("nrSolicitacao", nrSolicitacao.toString());

		this.httpClient.get(this.configService.getEndereco() + '/cotacao/getXls',
			{
				headers: this.configService.getHeaders(),
				params: httpParams,
				responseType: 'arraybuffer'
			}).subscribe(data => {

				const blob = new Blob([data], { type: 'application/octet-stream' });
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = `cotacao-${nrSolicitacao}.xls`;
				a.click();
				window.URL.revokeObjectURL(url);
			});
	}

	postXls(file: string, cdFilial: number, nrSolicitacao: number) {
		const body = {
			file: file
		};
		let httpParams = new HttpParams();
		httpParams = httpParams.
			append("cdFilial", cdFilial.toString()).
			append("nrSolicitacao", nrSolicitacao.toString());
		return this.httpClient.post(this.configService.getEndereco() + '/cotacao/postXls',
			body,
			{
				headers: this.configService.getHeaders(),
				params: httpParams,
			});
	}

}
